<div class="spinner" *ngIf="loading$ | async">
  <mat-spinner mode="indeterminate"></mat-spinner>
  <h2>Loading data, please wait...</h2>
</div>

<div class="container-1" *ngIf="!createPlan && !(loading$ | async)" id="table">
  <mat-card *ngIf="((clients$ | async) ?? []).length">
    <label class="header-label">
      <mat-icon class="primary-color">supervisor_account</mat-icon>
      Clients Diet Plan
    </label>
    <div class="search">
      <span>Search Any Value : </span>
      <mat-form-field>
        <input matInput (keyup)="applyFilter($event)" placeholder="Filter" />
      </mat-form-field>
      <button
        mat-icon-button
        matTooltip="Refresh Data"
        (click)="onRefresh()"
        [disabled]="loading$ | async"
        class="refresh-icon-right"
      >
        <mat-icon
          class="refresh-icon"
          [ngClass]="{ spinning: loading$ | async }"
          >refresh</mat-icon
        >
      </button>
    </div>
    <table mat-table [dataSource]="dataSource" matSort matSortActive="status">
      <ng-container
        *ngFor="let header of headers"
        matColumnDef="{{ header.id }}"
      >
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ header.label }}
        </th>
        <td mat-cell *matCellDef="let row">
          <button
            *ngIf="header.id === 'dietPlan'"
            mat-raised-button
            [ngClass]="{
              'new-btn':
                getLabel(row['status']) === 'Queastionnaire Not Filled',
              'active-btn':
                getLabel(row['status']) === 'Create' ||
                getLabel(row['status']) === 'Edit',
              'expired-btn': getLabel(row['status']) === 'View'
            }"
            (click)="rowClicked(row)"
          >
            {{ getLabel(row["status"]) }}
          </button>
          <button
            *ngIf="header.id === 'appointment'"
            mat-raised-button
            [ngClass]="{
              'apt-btn': getAptLabel(row) === 'Schedule Appointment',
              'follow-up-btn':
                getAptLabel(row) === 'Schedule Follow-Up ' + row.appointmentNo,
              'active-btn':
                getAptLabel(row) === 'Appointment Scheduled' ||
                getAptLabel(row) ===
                  'Follow-Up ' + (row.appointmentNo - 1 | number) + ' Scheduled'
            }"
            (click)="scheduleNewApt(row)"
            [disabled]="true"
          >
            {{ getAptLabel(row) }} &nbsp;
            <mat-icon>
              {{
                getAptLabel(row) === "Schedule Appointment"
                  ? "schedule"
                  : getAptLabel(row) ===
                    "Schedule Follow-Up " + row.appointmentNo
                  ? "alarm_on"
                  : "done_all"
              }}</mat-icon
            >
          </button>
          <p
            *ngIf="header.id !== 'dietPlan' && header.id !== 'appointment'"
            [ngStyle]="{
              color:
                row[header.id] === 'New'
                  ? '#2196F3'
                  : row[header.id] === 'Active'
                  ? '#4caf50'
                  : row[header.id] === 'Expired'
                  ? '#f44336'
                  : ''
            }"
            [ngClass]="{ status: header.id === 'status' }"
          >
            <mat-icon *ngIf="header.id === 'status'">account_circle</mat-icon>
            <button
              mat-raised-button
              *ngIf="header.id === 'edit'"
              (click)="onEdit(row)"
              color="basic"
            >
              Edit
              <mat-icon class="cursor-pointer">edit</mat-icon>
            </button>
            {{
              header.id === "packageAmnt" ||  header.id === "amntReceived" || header.id === "amntRemaining"
                ? (row['clientType'] === 'Domestic' ? "₹" : "$") &nbsp; + row[header.id]
                : row[header.id]
            }}
          </p>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
      [pageSize]="10"
      aria-label="Select page of periodic elements"
    >
    </mat-paginator>
  </mat-card>
</div>
<div class="back-btn">
  <button
    *ngIf="createPlan"
    mat-raised-button
    class="secondary-btn"
    (click)="back()"
  >
    <img [src]="backIcon" /> Back
  </button>
</div>
<div class="container-2" *ngIf="createPlan">
  <div class="left-section">
    <app-diet-plan [clientProfile]="rowData" [bmi]="bmi"></app-diet-plan>
  </div>
  <div class="right-section">
    <mat-accordion multi="true">
      <app-personal-info [userUID]="userUID"></app-personal-info>
      <app-body-measure
        [userUID]="userUID"
        (source)="bmi = $event"
      ></app-body-measure>
      <app-health-issues [userUID]="userUID"></app-health-issues>
      <app-daily-routine [userUID]="userUID"></app-daily-routine>
      <app-other-details [userUID]="userUID"></app-other-details>
    </mat-accordion>
  </div>
</div>
<!-- <app-file-upload></app-file-upload> -->
